import initVueApp from "@/core.js";
const component = require(`./../views/Collection.vue`).default;
initVueApp(component);
